import IntransigentBlocker, {
    INTRANSIGENT_BLOCKER_TARGET,
} from 'components/common/IntransigentBlocker/IntransigentBlocker'
import React, { useEffect } from 'react'

import clsx from 'clsx'
import { useStyles } from './styles'

interface LiveNoAccessProps {
    children: React.ReactNode
    header: string
    subheader: string
    stateId: string
}

const LiveNoAccess: React.FC<LiveNoAccessProps> = ({ children, header, subheader, stateId }) => {
    const classes = useStyles()
    useEffect(() => {
        const win: any = window
        if (win.document.pictureInPictureElement) {
            win.document.exitPictureInPicture()
        }
    }, [])
    return (
        <IntransigentBlocker property="filter" value="blur(17px)">
            <div
                className={clsx(classes.previewEndedWall)}
                data-header={header}
                data-subheader={subheader}
                data-testid={`${stateId}_wrapper`}
            >
                <div className={classes.videoWrapper} {...INTRANSIGENT_BLOCKER_TARGET}>
                    {children}
                </div>
            </div>
        </IntransigentBlocker>
    )
}

export default React.memo(LiveNoAccess)
